import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function CommunityGuidelines() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Community Guidelines</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-700 mb-6">
              BoardVoyage is committed to fostering a welcoming and inclusive community for all board game enthusiasts.
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Be Respectful</h2>
                <p className="text-gray-600">
                  Treat all members with respect and courtesy. We have zero tolerance for harassment, hate speech, or discriminatory behavior.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Play Fair</h2>
                <p className="text-gray-600">
                  Practice good sportsmanship. Winning is fun, but enjoying the game together is what matters most.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Be Inclusive</h2>
                <p className="text-gray-600">
                  Welcome new players and help them learn. Board gaming is for everyone, regardless of experience level.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Communicate Clearly</h2>
                <p className="text-gray-600">
                  Keep communication friendly and constructive. When disagreements arise, address them respectfully.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CommunityGuidelines;
